import { defineMessages } from 'react-intl';

export default defineMessages({
  signInHeaderStandard: {
    id: 'accountSignin.header.heading',
    defaultMessage: 'Sign in or create an account',
    description: 'Primary heading for sign in page',
  },
  signInPromoHeader: {
    id: 'accountSignin.header.promo.heading',
    defaultMessage: 'Sign in or create an account to redeem the offer',
    description: 'Primary heading for sign in page for redeeming promo',
  },
  signInHeaderPartnership: {
    id: 'accountSignin.header.partnershipGeneric',
    defaultMessage: 'Join or Sign in to finish linking your account',
    description: 'Generic partnership heading for sign in page',
  },
  signInDontHaveAnAccount: {
    id: 'accountSignin.header.dontHaveAnAccount',
    defaultMessage: "Don't have an account?",
    description: 'Primary heading to prompt non rewards customers',
  },
});
